import { useMutation } from "@tanstack/react-query";
import { apiPatch } from "../client";
import type { SubjectType } from "./types";

interface IUpdateSubjectRequest {
  subject: SubjectType;
  enabled: boolean;
}
export const useMutationUpdateSubject = () => {
  return useMutation({
    mutationFn: async ({
      progressId,
      request,
    }: {
      progressId: string;
      request: IUpdateSubjectRequest;
    }) => {
      return await apiPatch<IUpdateSubjectRequest>(
        `/exam_progress/${progressId}/subject`,
        request
      );
    },
  });
};
